module.exports = __webpack_public_path__ + "img/activity-icon.a63809b6.png";